var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container content-padding" }, [
    _vm.prices
      ? _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.provinceIds, function(provinceId) {
              return [
                _vm.globalState &&
                _vm.globalState.cities[provinceId] &&
                _vm.prices[provinceId]
                  ? _c(
                      "div",
                      {
                        key: "province_" + provinceId,
                        staticClass: "col-md-4"
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "price-plan" }, [
                              _c("h3", { staticClass: "price-city" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("multiLangName")(
                                      _vm.globalState.cities[provinceId]
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("currencyNoDecimal")(
                                      _vm.prices[provinceId][1]
                                    )
                                  )
                                ),
                                _c("span", [
                                  _vm._v(
                                    "/" + _vm._s(_vm.$tc("message.hour", 1.0))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("message.exclude_vat")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "price-plan" }, [
                              _c(
                                "ul",
                                _vm._l(_vm.workHours, function(workHour) {
                                  return _c(
                                    "li",
                                    { key: provinceId + "_" + workHour },
                                    [
                                      _vm._v(
                                        _vm._s(workHour) +
                                          " " +
                                          _vm._s(
                                            _vm.$tc("message.hour", workHour)
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("currencyNoDecimal")(
                                              _vm.prices[provinceId][workHour]
                                            )
                                          )
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-center mt--4" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary btn-lg mt-3",
                                    attrs: { to: "/booking/start", tag: "a" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("message.menu.book_cleaner")
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("p", { staticClass: "text-remark" }, [
                _vm._v(
                  "\n              BeNeat (บีนีท) แพลตฟอร์ม\n              เป็นเพียงเครื่องมือที่ใช้สำหรับการติดต่อสื่อสารระหว่างผู้ให้บริการกับผู้รับบริการเท่านั้น\n              ผู้ให้บริการเป็นผู้รับจ้างอิสระ (ซึ่งไม่ใช่ในฐานะลูกจ้าง คนงาน ตัวแทน ผู้ร่วมทุน หุ้นส่วน หรือ\n              ผู้ได้รับสิทธิพิเศษในการให้บริการจากบีนีท อย่างหนึ่งอย่างใดทั้งสิ้น\n              บีนีทไม่ได้เป็นผู้ให้บริการและจ้างบุคคลใดให้บริการเช่นว่านั้น\n              บทบาทของบีนีทจำกัดเพียงเสนอแพลตฟอร์มเทคโนโลยีให้เป็นเครื่องมือของท่านในการค้นหาผู้ให้บริการมืออาชีพ)\n              คุณภาพการให้บริการเป็นความรับผิดชอบทั้งสิ้นของผู้ให้บริการเอง ซึ่งท่านเป็นผู้ว่าจ้าง\n              ท่านพึงตระหนักว่าการเรียกใช้บริการจากผู้ให้บริการ อาจมีความเสี่ยง ซึ่งท่านรับทราบและยินดีใช้บริการ\n              บนความเสี่ยงใด ๆ ในความรับผิดชอบของตัวท่านเอง\n            "
                )
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b3ee263", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b3ee263","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Pricing.vue
// module id = 1519
// module chunks = 0